module.exports = __webpack_public_path__ + "static/media/logo167.72e37d3a.png";